import type { FC } from 'react'

import clsx from 'clsx'
import Select, { type GroupBase, type Props } from 'react-select'
import { typo } from 'shared/styles'

import css from './CustomSelect.module.scss'
import { DropdownIndicator } from './DropdownIndicator'

export const CustomSelect = <
	Option,
	IsMulti extends boolean = false,
	Group extends GroupBase<Option> = GroupBase<Option>
>({
	className,
	indicator,
	variant = 'default',
	...props
}: Props<Option, IsMulti, Group> & {
	indicator?: FC<any>
	variant?: 'default'
}) => (
	<Select
		className={clsx(css[variant], typo.buttonSm, className)}
		classNames={{
			control: ({ isDisabled, isFocused, isMulti, menuIsOpen }) =>
				clsx(css.control, typo.buttonSmB, {
					[css.disabled]: isDisabled,
					[css.focused]: isFocused,
					[css.open]: menuIsOpen,

					[css.withTags]: isMulti
				}),
			dropdownIndicator: () => css.indicator,
			input: () => css.input,
			menu: () => css.menu,
			menuList: () => clsx(css.list, 'app-scroll-thin'),

			multiValue: () => css.multi,
			multiValueLabel: () => css.tag,
			multiValueRemove: () => css.remove,
			option: ({ isSelected }) =>
				clsx(css.option, {
					[css.selected]: isSelected
				}),
			singleValue: () => css.single,
			valueContainer: () => css.container
		}}
		components={{
			// @ts-ignore false
			DropdownIndicator: indicator ?? DropdownIndicator,
			IndicatorSeparator: null
		}}
		{...props}
	/>
)
